import React from 'react';

export default {
  sm: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H16V16H0z" />
        <path
          className="icon-color"
          d="M9.25 12.765c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25.56-1.25 1.25-1.25 1.25.56 1.25 1.25"
        />
        <path
          className="icon-color"
          d="M3.703 2.293c-.39-.391-1.023-.391-1.414 0-.39.39-.39 1.023 0 1.414l1.361 1.36c-.857.442-1.656 1-2.357 1.702-.39.39-.39 1.023 0 1.414.39.39 1.023.39 1.414 0 .71-.71 1.54-1.25 2.438-1.62L6.55 7.968c-.826.23-1.607.663-2.257 1.312-.39.39-.39 1.024 0 1.414.195.196.451.293.707.293.256 0 .512-.097.707-.293.725-.723 1.71-1.018 2.656-.913l2.93 2.93c.195.195.451.293.707.293.256 0 .512-.098.707-.293.391-.391.391-1.023 0-1.414L3.703 2.293zM14.707 6.769C12.974 5.035 10.686 4.064 8.246 4l2.52 2.52c.934.37 1.795.928 2.527 1.661.195.195.451.293.707.293.256 0 .512-.098.707-.293.391-.39.391-1.022 0-1.413"
        />
      </g>
    </svg>
  ),
  md: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24">
      <g fill="none" fillRule="evenodd">
        <path d="M0 0H24V24H0z" />
        <path
          className="icon-color"
          d="M13.238 18.753c0 .69-.56 1.25-1.25 1.25s-1.25-.56-1.25-1.25.56-1.25 1.25-1.25 1.25.56 1.25 1.25M21.707 9.023c-2.593-2.593-6.04-4.02-9.707-4.02-1.145 0-2.265.147-3.347.417l1.709 1.71c.539-.076 1.084-.128 1.638-.128 3.133 0 6.078 1.22 8.293 3.435.195.195.451.293.707.293.256 0 .512-.098.707-.293.391-.39.391-1.023 0-1.414"
        />
        <path
          className="icon-color"
          d="M4.69 4.293c-.39-.391-1.023-.391-1.414 0-.39.391-.39 1.023 0 1.414l1.408 1.408c-.855.539-1.658 1.176-2.39 1.908-.392.391-.392 1.024 0 1.415.39.39 1.022.39 1.413 0 .737-.738 1.56-1.356 2.44-1.861l1.668 1.669c-.909.443-1.768 1.023-2.522 1.777-.39.391-.39 1.024 0 1.415.39.39 1.023.39 1.414 0 .767-.767 1.663-1.323 2.616-1.684l1.817 1.817c-1.072.177-2.063.668-2.847 1.452-.39.391-.39 1.024 0 1.415.39.39 1.023.39 1.414 0 .965-.966 2.495-1.159 3.7-.6l2.871 2.871c.195.195.451.293.707.293.256 0 .512-.098.707-.293.391-.391.391-1.023 0-1.414L4.69 4.293zM18.707 12.023c-1.721-1.72-3.944-2.63-6.202-2.75l2.703 2.703c.754.357 1.463.838 2.085 1.461.195.195.451.293.707.293.256 0 .512-.098.707-.293.391-.39.391-1.023 0-1.414"
        />
      </g>
    </svg>
  ),
};
